import { render, staticRenderFns } from "./SelectUnit.vue?vue&type=template&id=80980846&scoped=true&lang=pug&"
import script from "./SelectUnit.vue?vue&type=script&lang=ts&"
export * from "./SelectUnit.vue?vue&type=script&lang=ts&"
import style0 from "./SelectUnit.vue?vue&type=style&index=0&id=80980846&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80980846",
  null
  
)

export default component.exports